<div class="targeting-container">
  <label [ngStyle]="{'width': labelSectionWidth}">{{label}}</label>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div *ngIf="!hideEdit" [ngClass]="{'button-hidden' : hideAllButtons}">
    <acl-ngx-button id="edit-btn" variant="static" icon="Edit" (click)="onEditButtonClick()" [disabled]="disabled">
    </acl-ngx-button>
  </div>
  <div *ngIf="!hideRemove" [ngClass]="{'button-hidden' : hideAllButtons}">
    <acl-ngx-button id="remove-btn" variant="static" icon="Remove" (click)="onRemoveButtonClick()"
      [disabled]="disabled">
    </acl-ngx-button>
  </div>
</div>